/**
 * Use Case: Create Point Conversion Rate
 * Business logic for creating a new point conversion rate.
 */

import type {
  CreatePointConversionPayload,
  CreatePointConversionResult,
} from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Create a new point conversion rate
 */
export const CreatePointConversionRateUseCase = async (
  payload: CreatePointConversionPayload
): Promise<CreatePointConversionResult> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.createPointConversionRate(payload);
};

